// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1t58L","validationTips":"StatementDescriptor_validationTips__1Sn4_"};